export const PARALLEL_CHUNK_SIZE = 15;
export const REQUEST_TIMEOUT_MS = 28000;
export const MAX_RETRIES = 2;
export const RETRY_BASE_DELAY_MS = 400;

export const AUTO_INTERVAL_OPTIONS = [
  { label: 'Off', ms: 0 },
  { label: 'Every 2 min', ms: 120000 },
  { label: 'Every 5 min', ms: 300000 },
  { label: 'Every 10 min', ms: 600000 },
  { label: 'Every 15 min', ms: 900000 },
];

export const CLIENT_PRESETS = [
  {
    id: 'local_rhp',
    label: 'Local XAMPP (rhp)',
    apiBaseUrl: 'http://localhost/ebusso_react_api/ebussopromo',
  },
  {
    id: 'local_brit',
    label: 'Local (brit)',
    apiBaseUrl: 'http://localhost/ebusso_react_api/ebussopromo',
  },
  {
    id: 'api_ebusso',
    label: 'api.ebusso.com',
    apiBaseUrl: 'https://api.ebusso.com',
  },
  {
    id: 'api_ramee',
    label: 'api.rameesystems.com',
    apiBaseUrl: 'https://api.rameesystems.com',
  },
  {
    id: 'testapi_ramee',
    label: 'testapi.rameegroup.co.in',
    apiBaseUrl: 'https://testapi.rameegroup.co.in',
  },
];

export function normalizeBaseUrl(url) {
  if (!url || typeof url !== 'string') return '';
  return url.trim().replace(/\/+$/, '');
}

export function joinUrl(base, path) {
  const b = normalizeBaseUrl(base);
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${b}${p}`;
}

export function getHealthMonitorEnvApiBase() {
  const v = process.env.REACT_APP_HEALTH_API_BASE;
  return typeof v === 'string' && v.trim() ? normalizeBaseUrl(v) : '';
}
